import { render, staticRenderFns } from "./date-form.vue?vue&type=template&id=560c7a24"
import script from "./date-form.vue?vue&type=script&lang=js"
export * from "./date-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports